"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useState } from "react";
import { RenderImageContext, RenderImageProps, RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import ToggleEditIcon from "@/app/(main)/(club)/mes-clubs/[id]/components/toggle-edit-icon";
import { usePhotoAlbum } from "@/app/(main)/(club)/mes-clubs/[id]/hooks/use-photo-album";
import ComponentLoading from "@/components/global/component-loading";
import { CardTitle } from "@/components/global/titles/card-title";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { useModalStore } from "@/stores/modal-store";
import { Club } from "@/TS/Interfaces/global_interfaces";
import { PhotoHandler } from "./photo-handler";
interface PhotoGalleryProps {
  club: Club;
  isPresident: boolean;
}
export const PhotoGallery = t0 => {
  const $ = _c(18);
  const {
    club,
    isPresident
  } = t0;
  const [isEditing, setIsEditing] = useState(false);
  const [index, setIndex] = useState(-1);
  const {
    data: t1,
    isLoading
  } = usePhotoAlbum(club);
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const photos = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function renderNextImage(t4, t5) {
      const {
        alt,
        title
      } = t4;
      const {
        photo
      } = t5;
      return <div style={{
        width: "100%",
        position: "relative",
        aspectRatio: `${photo.width} / ${photo.height}`
      }}><Image fill={true} key={photo.src} src={photo.src} alt={alt ?? ""} title={title ?? ""} /></div>;
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const renderNextImage = t3;
  let t4;
  if ($[3] !== club || $[4] !== isEditing) {
    t4 = () => {
      setIsEditing(!isEditing);
      useModalStore.getState().open({
        component: <PhotoHandler club={club} setIsEditing={setIsEditing} />,
        modalOptions: {
          closeOnOverlayClick: false,
          onClose() {
            setIsEditing(false);
          }
        }
      });
    };
    $[3] = club;
    $[4] = isEditing;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleOpenModal = t4;
  let t5;
  if ($[6] !== handleOpenModal || $[7] !== isEditing || $[8] !== isPresident) {
    t5 = isPresident && <div className="absolute right-4 top-4"><ToggleEditIcon isEditing={isEditing} onToggle={handleOpenModal} /></div>;
    $[6] = handleOpenModal;
    $[7] = isEditing;
    $[8] = isPresident;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CardTitle title="Photos du club" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== index || $[12] !== isLoading || $[13] !== photos) {
    t7 = isLoading ? <ComponentLoading /> : photos && photos.length > 0 ? <div className="grid gap-4"><RowsPhotoAlbum photos={photos} render={{
        image: renderNextImage
      }} sizes={{
        size: "1168px",
        sizes: [{
          viewport: "(max-width: 1200px)",
          size: "calc(100vw - 32px)"
        }]
      }} onClick={t8 => {
        const {
          index: index_0
        } = t8;
        return setIndex(index_0);
      }} /><Lightbox slides={photos} open={index >= 0} index={index} close={() => setIndex(-1)} plugins={[Fullscreen, Slideshow, Zoom]} /></div> : <div className="grid place-items-center"><Image src="/img/light-bulb.png" alt="photos" width={50} height={50} /><p className="text-center"><strong>Ajoutez des photos de votre club, membres ou évènements !</strong></p><p className="text-center">Cela rendra votre club et votre page plus attractive.</p></div>;
    $[11] = index;
    $[12] = isLoading;
    $[13] = photos;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className="rounded relative bg-white p-4 border border-light-grey pb-8 bg-red-500">{t5}{t6}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};